import { render, staticRenderFns } from "./CardPayment.vue?vue&type=template&id=bf1cf1f0"
import script from "./CardPayment.vue?vue&type=script&lang=js"
export * from "./CardPayment.vue?vue&type=script&lang=js"
import style0 from "./CardPayment.vue?vue&type=style&index=0&id=bf1cf1f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports